import _ from 'lodash';
import {
    FETCH_RAINPRO_POINTS,
    CLEAN_RAINPRO_POINTS,
    CHANGE_RAINPRO_POINT,
    DELETE_RAINPRO_POINT,
} from './types';
import { request, __ } from '../functions';

export const fetchRainproPoints = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/rainpro/points', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_RAINPRO_POINTS, payload: data });
    });
};

export const changeRainproPoint = (screen, id, data) => {
    return dispatch => request(`/rainpro/editPoint/${id}`, { data }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť výdajné miesto'));
            return;
        }

        screen.showSnackbar('success', __('Výdajné miesto bolo zmenené'));

        dispatch({ type: CHANGE_RAINPRO_POINT, payload: { id, data } });
    });
};

export const deleteRainproPoint = (screen, id) => {
    return dispatch => request(`/rainpro/removePoint/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať výdajné miesto'));
            return;
        }

        screen.showSnackbar('success', __('Výdajné miesto bolo zmazané'));

        dispatch({ type: DELETE_RAINPRO_POINT });
    });
};

export const cleanRainproPoints = () => ({ type: CLEAN_RAINPRO_POINTS });
